import React, { Children, cloneElement } from 'react';
import CurrencyInput from 'react-currency-input-field';
import RenderError from './RenderError';

function BasicInfoUnitForm({
  equipmentType,
  two = false,
  formData,
  setFormData,
  errors,
  children
}) {
  const states = wlFipApplicationData.usStates;
  const handleInputChange = (event, two) => {
    let unit = !two ? 'unitOne' : 'unitTwo';

    if (event.target.files) {
      let { name, files } = event.target;
      setFormData({
        ...formData,
        [unit]: { ...formData[unit], [name]: files[0] }
      });
    } else {
      let { name, value } = event.target;
      setFormData({
        ...formData,
        [unit]: { ...formData[unit], [name]: value }
      });
    }
  };

  const handleCurrencyInputChange = (name, value, two) => {
    let unit = !two ? 'unitOne' : 'unitTwo';
    setFormData({
      ...formData,
      [unit]: { ...formData[unit], [name]: parseInt(value) }
    });
  };

  let unit = two ? 'unitTwo' : 'unitOne';

  const additionalFields = Children.map(children, (child) =>
    cloneElement(child, {
      two: two,
      unit: unit,
      handleInputChange: handleInputChange,
      handleCurrencyInputChange: handleCurrencyInputChange,
      equipmentType: equipmentType,
      formData: formData,
      setFormData: setFormData,
      errors: errors
    })
  );

  return (
    <div className="fip-unit-form">
      <label className="form__label fip-unit-label">
        {two ? 'Unit Two' : 'Unit One'}
      </label>
      <div className="fip-unit-form-fields">
        {equipmentType === 'flame_weeding' && additionalFields}
        <div className="form__field form__field--required">
          <label
            className="form__label u--margin-right-20"
            htmlFor="purchaseDate"
          >
            Purchase Date:
          </label>
          <input
            type="date"
            name="purchaseDate"
            max="9999-12-31"
            value={formData[two ? 'unitTwo' : 'unitOne'].purchaseDate}
            className="form__input form__input--lg"
            onChange={(event) => handleInputChange(event, two)}
          />
          {errors[`${equipmentType}_${unit}`] && (
            <RenderError
              error={errors[`${equipmentType}_${unit}`].purchaseDate}
            />
          )}
        </div>
        <div className="form__field form__field--required">
          <label
            className="form__label u--margin-right-20"
            htmlFor="purchaseAmount"
          >
            Purchase Amount:{' '}
          </label>
          <CurrencyInput
            name="purchaseAmount"
            className="form__input form__input--lg"
            prefix="$"
            value={
              formData[unit].purchaseAmount !== null &&
              formData[unit].purchaseAmount !== undefined
                ? parseInt(formData[unit].purchaseAmount)
                : 0
            }
            min={0}
            onValueChange={(value, name) =>
              handleCurrencyInputChange(name, value, two)
            }
            allowNegativeValue={false}
          />
          {errors[`${equipmentType}_${unit}`] && (
            <RenderError
              error={errors[`${equipmentType}_${unit}`].purchaseAmount}
            />
          )}
        </div>
        <div className="form__field form__field--required">
          <label
            className="form__label u--margin-right-20"
            htmlFor="manufacturer"
          >
            Manufacturer (Brand):{' '}
          </label>
          <input
            type="text"
            name="manufacturer"
            value={formData[unit].manufacturer}
            className="form__input form__input--lg"
            onChange={(event) => handleInputChange(event, two)}
          />
          {errors[`${equipmentType}_${unit}`] && (
            <RenderError
              error={errors[`${equipmentType}_${unit}`].manufacturer}
            />
          )}
        </div>
        <div className="form__field form__field--required">
          <label className="form__label u--margin-right-20" htmlFor="model">
            Model:{' '}
          </label>
          <input
            type="text"
            name="model"
            value={formData[unit].model}
            className="form__input form__input--lg"
            onChange={(event) => handleInputChange(event, two)}
          />
          {errors[`${equipmentType}_${unit}`] && (
            <RenderError error={errors[`${equipmentType}_${unit}`].model} />
          )}
        </div>
        <div className="form__field form__field--required">
          <label
            className="form__label u--margin-right-20"
            htmlFor="serialNumber"
          >
            Serial Number:{' '}
          </label>
          <input
            type="text"
            name="serialNumber"
            value={formData[unit].serialNumber}
            className="form__input form__input--lg"
            onChange={(event) => handleInputChange(event, two)}
          />
          {errors[`${equipmentType}_${unit}`] && (
            <RenderError
              error={errors[`${equipmentType}_${unit}`].serialNumber}
            />
          )}
        </div>
        <div
          className={`form__field ${
            !formData[unit].receipt && 'form__field--required'
          }`}
        >
          {Boolean(parseInt(formData[unit].receipt) > 0) && (
            <p className="u--margin-bottom-10">
              We have your receipt for this unit on file.
            </p>
          )}
          <label className="form__label u--margin-right-20" htmlFor="receipt">
            Receipt:
          </label>
          <input
            type="file"
            name="receipt"
            onChange={(event) => handleInputChange(event, two)}
          />
          {errors[`${equipmentType}_${unit}`] && (
            <RenderError error={errors[`${equipmentType}_${unit}`].receipt} />
          )}
        </div>
        <div className="form__field form__field--required">
          <label
            className="form__label u--margin-right-20"
            htmlFor="equipmentDealer"
          >
            Equipment Dealer:
          </label>
          <input
            type="text"
            name="equipmentDealer"
            value={formData[unit].equipmentDealer}
            className="form__input form__input--lg"
            onChange={(event) => handleInputChange(event, two)}
          />
          {errors[`${equipmentType}_${unit}`] && (
            <RenderError
              error={errors[`${equipmentType}_${unit}`].equipmentDealer}
            />
          )}
        </div>
        <div className="form__field form__field--required">
          <label className="form__label" htmlFor="state">
            What state will the equipment be used in:{' '}
          </label>
          <div className="form__select form__select--lg">
            <select
              onChange={(event) => handleInputChange(event, two)}
              defaultValue={formData[unit].state}
              name="state"
            >
              <option value="">Select a State</option>
              {Object.values(states).map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
            {errors[`${equipmentType}_${unit}`] && (
              <RenderError error={errors[`${equipmentType}_${unit}`].state} />
            )}
          </div>
        </div>
        {equipmentType !== 'flame_weeding' && additionalFields}
      </div>
    </div>
  );
}

export default BasicInfoUnitForm;
